import http from "./http"
import store from "./store"

export default http({
  transformRequest: [
    function (options) {
      const { token } = store.get.auth()
      return {
        ...options,
        headers: {
          ...options.headers,
          Authorization: `Bearer ${token}`,
        },
      }
    },
  ],
})
